import {getId} from 'apis/model/base'
import classNames from 'classnames'
import React, {useContext, useState} from 'react'
import {renderSelf} from 'views/Shared'
import {renderCourseClassTeacherAssignment} from '../../../Workspace/Course/functions/renderCourseClassTimetable'
import {ActionModalWrapper} from '../../../../components/form/ActionModalWrapper'
import EntityList from '../../EntityList'
import {bindQueryParams} from '../../functions/routerHelper'
import useTranslate from '../../../../modules/local/useTranslate'
import {useTimetableCourseClassForm} from '../../Timetable/useTimetableCourseClassForm'
import {timetable_getMilestonesByCourseClass_Api} from '../../../../apis'
import {BsInboxesFill} from 'react-icons/bs'
import {LayoutContext} from '../../../../components/layouts/Default/LayoutContext'
import {NullAsDefault} from '../../../Shared'

export const CourseClassTimetables = ({
                                          item: courseClass,
                                          header = null,
                                          renderFooter = renderSelf,
                                      }) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const [filterSubject, setFilterSubject] = useState(false)
    const [refreshKey, setRefreshKey] = useState();
    const {
        modal,
        renderContextMenu,
        handleAction = NullAsDefault,
    } = useTimetableCourseClassForm({course_class: courseClass, refreshKey, setRefreshKey})
    const {class_subjects = []} = courseClass ?? {}

    return (
        <ActionModalWrapper style={{ fontSize: 14 }} className="px-3 flex-1">
            {header}
            <div className="flex flex-col gap-1">
                <div className="flex flex-col">
                    <div className="font-semibold text-base text-slate-600 tracking-wide">
                        {t('timetable for the class')}
                    </div>
                    <div style={{ height: 3 }} className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
                </div>
                <div className="flex flex-col gap-1">
                    {class_subjects.length > 0 && (
                        <div className="flex items-baseline flex-wrap gap-1">
                            <span className="text-color-400 whitespace-no-wrap leading-snug tracking-wider 111-111">
                                {`${t('subjects')} : `}
                            </span>
                            <div className="ml-1 flex flex-wrap gap-y-1 gap-x-2">
                                {class_subjects.map((e, i) => (
                                    <span
                                        key={i}
                                        style={{padding: '2px 8px', height: 28, borderRadius: 6}}
                                        className={classNames(
                                            "flex flex-center cursor-pointer rounded-md font-medium",
                                            filterSubject === e ?
                                                "bg-blue-100 hover:bg-blue-200 text-blue-600" :
                                                "background-100 hover:bg-blue-50 text-color-300 hover:text-blue-500"
                                        )}
                                        onClick={() => {
                                            if (filterSubject === e) {
                                                setFilterSubject(null)
                                            } else {
                                                setFilterSubject(e)
                                            }
                                        }}>
                                        {e?.subject?.title}
                                    </span>
                                ))}
                            </div>
                        </div>
                    )}
                    <div className="mt-3 flex flex-col">
                        {!!courseClass?.id && (
                            <EntityList
                                refreshKey={refreshKey}
                                key={filterSubject?.subject?.id}
                                RenderEntity={React.Fragment}
                                values={{subject_id: filterSubject?.subject?.id}}
                                query={bindQueryParams([{id: getId(courseClass)}])}
                                apiInfo={timetable_getMilestonesByCourseClass_Api}
                                renderItem={renderCourseClassTeacherAssignment({renderContextMenu})}
                                renderWrap={(child) => (
                                    <div className="flex flex-col divide-y divide-gray-200 list-item-workspace">
                                        {child}
                                    </div>
                                )}
                                renderEmpty={() => (
                                    <div className="p-6 flex flex-col items-center gap-3 border border-color-50 rounded-xl shadow-md">
                                        <BsInboxesFill size={40} style={{color: '#dedede'}}/>
                                        <span className="text-center text-sm text-color-300 tracking-wider italic">
                                            {t('no data is available now')}
                                        </span>
                                    </div>
                                )}
                            />
                        )}
                    </div>
                </div>
            </div>
            {renderFooter(null)}
            {modal}
        </ActionModalWrapper>
    )
}
